import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';

interface Stats {
  total: number;
  male: number;
  female: number;
  completed: number;
  pending: number;
}

export default function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/admin/stats')
      .then(res => { setStats(res.data); setLoading(false); })
      .catch(() => navigate('/admin/login'));
  }, [navigate]);

  const cards = stats ? [
    { label: '总人数', value: stats.total, color: 'bg-blue-50 text-blue-700' },
    { label: '男生', value: stats.male, color: 'bg-indigo-50 text-indigo-700' },
    { label: '女生', value: stats.female, color: 'bg-pink-50 text-pink-700' },
    { label: '已完成', value: stats.completed, color: 'bg-green-50 text-green-700' },
    { label: '未完成', value: stats.pending, color: 'bg-yellow-50 text-yellow-700' },
  ] : [];

  const navItems = [
    { label: '名单管理', path: '/admin/roster' },
    { label: '书院管理', path: '/admin/colleges' },
    { label: '题目管理', path: '/admin/questions' },
    { label: '运行分配', path: '/admin/assign' },
    { label: '导出名单', path: '/admin/export' },
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800">管理员后台</h1>
          <button
            onClick={() => { localStorage.removeItem('admin_token'); navigate('/admin/login'); }}
            className="text-sm text-gray-500 hover:text-red-500"
          >
            退出登录
          </button>
        </div>

        <h2 className="text-lg font-semibold text-gray-700 mb-4">答题进度</h2>
        {loading ? (
          <p className="text-gray-400">加载中...</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
            {cards.map(card => (
              <div key={card.label} className={`rounded-xl p-4 ${card.color}`}>
                <p className="text-sm opacity-70">{card.label}</p>
                <p className="text-3xl font-bold mt-1">{card.value}</p>
              </div>
            ))}
          </div>
        )}

        <h2 className="text-lg font-semibold text-gray-700 mb-4">功能菜单</h2>
        <div className="grid grid-cols-2 gap-4">
          {navItems.map(item => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="bg-white rounded-xl p-6 text-left shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <p className="font-semibold text-gray-800">{item.label}</p>
              <p className="text-sm text-gray-400 mt-1">点击进入 →</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
